// Key status (KD-01). Mirrors api/src/utils/setKeyStatus.js: rows written
// before the status column existed have status null and read from the flags.

export function keyStatusOf(room) {
  if (room?.status) return room.status
  if (Number(room?.distributed) === 1) return 'distributed'
  if (Number(room?.ready) === 1) return 'ready'
  return 'not_ready'
}

const BADGES = {
  not_ready: 'bg-secondary',
  ect_confirmed: 'bg-azure',
  ready: 'bg-info',
  delayed: 'bg-orange',
  distributed: 'bg-success'
}

export function keyStatusBadgeClass(room) {
  return BADGES[keyStatusOf(room)] || 'bg-secondary'
}

export function keyStatusLabel(room, dict) {
  const status = keyStatusOf(room)
  return dict?.keyStatus?.[status] || status.replace('_', ' ')
}

// Filter options on the PWA key list, in the order admin lists them.
export const KEY_STATUSES = ['not_ready', 'ect_confirmed', 'ready', 'delayed', 'distributed']

/**
 * Whether a room passes the key list filter. Blocked is a flag, not a status
 * (KD-02), so it is filtered on its own, as on admin.
 * @param {object} room
 * @param {{status?: string, blocked?: 'all'|'blocked'|'not_blocked'}} filter
 */
export function matchesKeyFilter(room, {status = 'all', blocked = 'all'} = {}) {
  if (status !== 'all' && keyStatusOf(room) !== status) return false
  const isBlocked = Number(room?.blocked) === 1 || room?.blocked === true
  if (blocked === 'blocked' && !isBlocked) return false
  if (blocked === 'not_blocked' && isBlocked) return false
  return true
}

/** '18:00' when today (or no date), '18:00 13/12' on another day. */
export function formatEct(time, date, today = new Date().toLocaleDateString('en-CA')) {
  if (!time) return ''
  if (!date || date === today) return time
  const [, m, d] = date.split('-')
  return `${time} ${d}/${m}`
}
